import React from 'react'; // Styles

import './loading-string.scss';

function LoadingString(_a) {
  var children = _a.children;
  return React.createElement(React.Fragment, null, children, React.createElement("span", {
    className: "loading-string"
  }, React.createElement("span", null, "."), React.createElement("span", null, "."), React.createElement("span", null, ".")));
}

export default LoadingString;